import { TASK_COMMENT_MAX_LENGTH } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { Button, Form, FormTextarea } from '@sib/ui';
import {
  COMMENT_TEXTAREA_ROWS,
  TaskNewCommentField,
  useTaskNewCommentForm,
} from './TaskNewCommentForm.utils';

interface TaskNewCommentFormProps {
  taskId: string;
  onGoBack: () => void;
}

export const TaskNewCommentForm = ({
  taskId,
  onGoBack,
}: TaskNewCommentFormProps) => {
  const { t } = useTranslation();
  const { formProps, onSubmit, isPending, isValid } = useTaskNewCommentForm({
    taskId,
    onSuccess: onGoBack,
  });

  return (
    <Form
      {...formProps}
      onSubmit={onSubmit}
      className="flex h-full w-full flex-col gap-6"
    >
      <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto">
        <h3 className="text-primary text-lg">
          {t('components.taskDetails.comments.newComment')}
        </h3>

        <FormTextarea
          name={TaskNewCommentField.Text}
          label={t('components.taskDetails.comments.yourComment')}
          placeholder={t('components.taskDetails.comments.placeholder')}
          rows={COMMENT_TEXTAREA_ROWS}
          maxLength={TASK_COMMENT_MAX_LENGTH}
          disabled={isPending}
          className="resize-none"
        />
      </div>

      <div className="flex shrink-0 justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          disabled={isPending}
          onClick={onGoBack}
        >
          {t('cancel')}
        </Button>
        <Button type="submit" disabled={!isValid} loading={isPending}>
          {t('save')}
        </Button>
      </div>
    </Form>
  );
};
